import { all, fork } from 'redux-saga/effects'
import procurementApprovalsSage from "./purchaseRequest.sagas";
import filterSaga from './filter.saga'

export default function* rootSaga() {
  yield all([
    fork(procurementApprovalsSage),
    fork(filterSaga)
  ])
};